import { render, staticRenderFns } from "./PassengerOptionSelector.vue?vue&type=template&id=67804ba9&scoped=true&lang=pug"
import script from "./PassengerOptionSelector.vue?vue&type=script&lang=js"
export * from "./PassengerOptionSelector.vue?vue&type=script&lang=js"
import style0 from "./PassengerOptionSelector.vue?vue&type=style&index=0&id=67804ba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67804ba9",
  null
  
)

export default component.exports